// extracted by mini-css-extract-plugin
export var bottom = "side-bar-module--bottom--927ae";
export var enter = "side-bar-module--enter--40133";
export var enterActive = "side-bar-module--enterActive--3ea4d";
export var enterDone = "side-bar-module--enterDone--6ab0a";
export var exit = "side-bar-module--exit--0f0d6";
export var exitActive = "side-bar-module--exitActive--3edf9";
export var facebook = "side-bar-module--facebook--c7de4";
export var gamesList = "side-bar-module--gamesList--60d61";
export var hotTopicsTitle = "side-bar-module--hotTopicsTitle--249b1";
export var navLink = "side-bar-module--navLink--349dc";
export var playerOpen = "side-bar-module--playerOpen--370be";
export var sideBar = "side-bar-module--sideBar--43884";
export var socialLink = "side-bar-module--socialLink--71efc";
export var socialLinkList = "side-bar-module--socialLinkList--c963b";
export var top = "side-bar-module--top--7dc71";
export var x = "side-bar-module--x--49069";
export var xPop = "side-bar-module--xPop--58e9f";
export var youTube = "side-bar-module--youTube--ec35e";